import { inject, observer } from "mobx-react";
import { AlertDataStore } from "../../../store/store";
import styles from "./../edit-alert.module.css";
import { SwitchInput } from "../../../../../components/form-inputs";
import { ChangeEvent } from "react";
import { alertDataSchema } from "../../../validation";

export interface GenericToggleProps {
  alertDataStore?: AlertDataStore;
}

function TriggerWhileNursePresentToggle(props: GenericToggleProps) {
  const alertDataStore = props.alertDataStore!;

  const value = alertDataStore.selectedAlert.triggerWhileNursePresent;

  return (
    <div className={styles["edit-column-content"]}>
      <SwitchInput
        checked={value}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          const schema = alertDataSchema;

          alertDataStore.setSelectedTriggerWhileNursePresent(
            event.target.checked
          );

          alertDataStore.validateSelectedAlert(schema);
          alertDataStore.setValidated(true);
        }}
      ></SwitchInput>
    </div>
  );
}

export default inject("alertDataStore")(
  observer(TriggerWhileNursePresentToggle)
);
